<template>
  <el-form
    ref="feesForPaidPassengersMasterForm"
    :model="model"
    :rules="rules"
    label-width="12.5em"
    label-position="left"
    class="fees-for-paid-passengers-master-form"
  >
    <div class="el-form--inline">
    <ChargeYear v-model="chargeYear" label="料金年度"  prop="charge_year" yearType = "reference"  :required="true" :searchCond="true" :disabled="editMode" :autofocus="!editMode" :initialize="true" :tableType = tableType mode = "this" />
    <!-- <BillingYm v-model="billingYm" :required="true" :searchCond="true" :mode="billingYmMode" :disabled="editMode" :autofocus="!editMode" /> -->
    <Select v-model="routeCode" label="線別" prop="route_code" :required="!searchMode" :searchCond="searchMode" :disabled="editMode" codeId="ROUTE_CODE" :initialize="true" />
    </div>
    <div class="el-form--inline">
    <Select v-model="jetType" label="ジェット区分" prop="jet_type" :required="!searchMode" :searchCond="searchMode" :disabled="editMode" codeId="JET_TYPE" :initialize="true" />
    <Select v-model="paidType" label="有償区分" prop="paid_type" :required="!searchMode" :searchCond="searchMode" :disabled="editMode" codeId="PAID_TYPE" :initialize="true" />
    </div>
    <el-divider />
    <div class="el-form--inline">
      <Numeric v-model="charge" label="単価" prop="charge"
          :required="!searchMode" :searchCond="searchMode" :min="0" :max="9999" :step="1" :disabled="editDisabledMode && editMode" />
      <Numeric v-model="maxPassengersRate" label="最大利用座席割合[%]" prop="max_passengers_rate"
          :required="!searchMode" :searchCond="searchMode" :min="0" :max="100" :step="1" :disabled="editDisabledMode && editMode" />
    </div>
    <div class="el-form--inline">
      <el-col class="caution">
        ※減免率は着陸料金マスタ[重量・騒音]で設定したものが適用されます。
      </el-col>
    </div>
    <template v-if='formMode === "edit" '>
      <el-divider />
      <div class="el-form--inline">
        <DateTime v-model="updatedOn" label="更新日時" prop="updated_on"
            :required="!searchMode" :searchCond="searchMode" :disabled="editMode"
            format="yyyy/MM/dd HH:mm:ss" />
        <Blank />
      </div>
    </template>
    <el-divider />
  </el-form>
</template>

<script>
import ChargeYear from '@/components/molecules/form/select/ChargeYear.vue'
import Select from '@/components/molecules/form/select/Select.vue'
import Numeric from '@/components/molecules/form/number/Numeric.vue'
import DateTime from '@/components/molecules/form/date/DateTime.vue'
import Blank from '@/components/molecules/form/text/Blank.vue'

export default {
  components: {
    ChargeYear,
    Select,
    Numeric,
    DateTime,
    Blank
  },
  model: {
    prop: 'model'
  },
  props: {
    model: Object,
    formMode: {
      type: String,
      default: 'search'
    },
    rules: Object,
    // billingYmMode: {
    //   type: String,
    //   default: 'search'
    // },
    editDisabledMode: {
      type: Boolean,
      default: false
    },
    tableType: String
  },
  data () {
    return {}
  },
  computed: {
    chargeYear: {
      get () {
        return this.model.charge_year
      },
      set (chargeYear) {
        const form = { ...this.model }
        form.charge_year = chargeYear
        this.$emit('input', form)
      }
    },
    routeCode: {
      get () {
        return this.model.route_code
      },
      set (routeCode) {
        const form = { ...this.model }
        form.route_code = routeCode
        this.$emit('input', form)
      }
    },
    jetType: {
      get () {
        return this.model.jet_type
      },
      set (jetType) {
        const form = { ...this.model }
        form.jet_type = jetType
        this.$emit('input', form)
      }
    },
    paidType: {
      get () {
        return this.model.paid_type
      },
      set (paidType) {
        const form = { ...this.model }
        form.paid_type = paidType
        this.$emit('input', form)
      }
    },
    charge: {
      get () {
        return this.model.charge
      },
      set (charge) {
        const form = { ...this.model }
        form.charge = charge
        this.$emit('input', form)
      }
    },
    maxPassengersRate: {
      get () {
        return this.model.max_passengers_rate
      },
      set (maxPassengersRate) {
        const form = { ...this.model }
        form.max_passengers_rate = maxPassengersRate
        this.$emit('input', form)
      }
    },
    updatedOn: {
      get () {
        return this.model.updated_on
      },
      set (updatedOn) {
        const form = { ...this.model }
        form.updated_on = updatedOn
        this.$emit('input', form)
      }
    },
    searchMode: {
      get () {
        return this.formMode === 'search'
      }
    },
    editMode: {
      get () {
        return this.formMode === 'edit'
      }
    }
  },
  mounted () {
  },
  methods: {
    clearFields () {
      this.$refs.feesForPaidPassengersMasterForm.resetFields()
      // this.billingYm = this.getDefaultBillingYm()
      // if (this.searchMode) {
      //   this.model.manual_data_only = false
      //   this.model.automatic_data_only = false
      // }
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.feesForPaidPassengersMasterForm.validate((valid) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(new Error('validate error'))
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
.fees-for-paid-passengers-master-form {
  .el-form--inline {
    display: flex;
    justify-content: space-between;
    // margin-left: 10px;
  }
}
.caution {
  color: red;
}
</style>
